import { render, staticRenderFns } from "./Assign.vue?vue&type=template&id=d69dbf24&scoped=true&"
import script from "./Assign.vue?vue&type=script&lang=js&"
export * from "./Assign.vue?vue&type=script&lang=js&"
import style0 from "./Assign.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Assign.vue?vue&type=style&index=1&id=d69dbf24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d69dbf24",
  null
  
)

export default component.exports